{
  "back": "Wstecz",
  "form": "Formularz",
  "purposeTitle": "Jaki jest cel Twojego postoju?",
  "appointmentInfoTitle": "Informacje o wizycie",
  "appointmentInfoHint": "Upewnij się, że wypełnisz to pole, jeśli masz wizytę.",
  "checkInDetailsTitle": "Szczegóły zameldowania",
  "checkInDetailsHint": "Dodatkowe informacje o Twojej wizycie.",
  "driverPhoneLabel": "Numer telefonu kierowcy",
  "activateWhatsAppTitle": "Aktywuj wiadomości WhatsApp",
  "activateWhatsAppBody": "Aby porozmawiać z magazynem, odpowiedz \"OK\" gdy wyślemy Ci pierwszą wiadomość WhatsApp.",
  "whatsappDelayBanner": "Pierwsza wiadomość WhatsApp może dotrzeć z opóźnieniem do jednej minuty.",
  "notesLabel": "Notatki",
  "notesPlaceholder": "Specjalne instrukcje lub uwagi dla obiektu?",
  "addNoteToWarehouse": "Dodaj notatkę dla magazynu",
  "verifyAndCheckIn": "Zweryfikuj i zamelduj się",
  "completeCheckIn": "Zakończ zameldowanie",
  "visitGroupInbound": "Przychodzące",
  "visitGroupOutbound": "Wychodzące",
  "visitGroupBoth": "Przychodzące i wychodzące",
  "visitUnloadTruck": "Rozładuj mój pojazd",
  "visitDropTrailer": "Zostaw moją naczepę lub kontener",
  "visitLoadTruck": "Załaduj mój pojazd",
  "visitHookTrailer": "Podepnij naczepę lub kontener",
  "visitUnloadLoad": "Rozładuj i załaduj mój pojazd",
  "visitDropHook": "Zostaw i podepnij naczepę lub kontener",
  "containerTrailer": "Naczepa",
  "containerContainer": "Kontener",
  "containerOversized": "Ponadgabarytowy",
  "containerOther": "Inne",
  "defaultReferenceName": "Numer zamówienia",
  "identifierSuffix": "{reference} lub numer potwierdzenia",
  "licenseOrDotRequired": "Proszę podać numer rejestracyjny lub numer DOT",
  "appointmentNotFound": "Nie mogliśmy zlokalizować Twojej wizyty",
  "referenceNotFound": "Nie znaleziono pasującej wizyty. Numery referencyjne rozróżniają wielkość liter.",
  "referenceCaseSensitiveHint": "Numer referencyjny rozróżnia wielkość liter",
  "messaging": {
    "whatsappFailedTitle": "Nie można wysłać wiadomości WhatsApp",
    "smsFailedTitle": "Nie można wysłać wiadomości SMS",
    "whatsappFailedBody": "Nie mogliśmy wysłać wiadomości na numer {displayPhone}. <br /><br /> Jeśli wcześniej zrezygnowałeś z subskrypcji, wyślij START na numer <a href='{waUrl}' target='_blank' rel=\"noopener noreferrer\">{senderPhone}</a>, aby ponownie otrzymywać wiadomości z tego magazynu.",
    "smsFailedBody": "Nie mogliśmy wysłać wiadomości na numer {displayPhone}. <br /><br /> Jeśli wcześniej zrezygnowałeś z subskrypcji, wyślij START na numer <a href='{smsUrl}'>{senderPhone}</a>, aby ponownie otrzymywać wiadomości SMS z tego magazynu.",
    "fallbackPhone": "podany numer telefonu"
  }
}
